import React from "react";

import gelato from "../assets/images/gelato-1.png";
import metamask from "../assets/images/metamask.png";

interface NavBarProps {
  connected: boolean;
  address: string;
  connectButton: (params: any) => any;
}

const NavBar = (props: NavBarProps) => {
  return (
    <div className="navbar bg-base-100 logo-navbar">
      <div className="flex-1">
        <a 
          href="https://lens-gpt.web.app"
      className="btn btn-ghost normal-case text-xl">
          <svg   height={32}
            viewBox="0 0 908 285"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M166.868 82.9553C166.845 86.9153 163.209 89.7161 159.279 89.3019C149.537 88.275 140.612 88.3604 132.267 89.2309C114.105 91.1259 99.0102 96.7361 85.0944 101.908L85.0638 101.92C84.2218 102.233 83.384 102.544 82.5502 102.853C67.7739 108.325 54.1582 113.033 38.0041 113.407C31.56 113.556 24.6175 113.013 16.9727 111.473C10.416 110.152 5.17757 105.14 3.87835 98.5652C2.84886 93.3555 2.30908 87.9693 2.30908 82.4568C2.30908 36.9172 39.1472 0 84.5893 0C130.031 0 166.87 36.9172 166.87 82.4568C166.87 82.6231 166.869 82.7893 166.868 82.9553Z"
              fill="url(#paint0_radial_1966_10540)"
            ></path>
            <path
              d="M9.62462 123.93C3.4459 122.442 -2.19264 129.096 0.850232 134.686L81.6146 283.072C82.914 285.46 86.3347 285.46 87.6341 283.072L176.777 119.294C179.938 113.485 176.896 106.208 170.421 104.912C156.335 102.092 144.334 101.788 133.652 102.903C117.262 104.613 103.65 109.666 89.5191 114.912C88.7705 115.19 88.0204 115.468 87.2684 115.747C72.4751 121.225 56.9499 126.717 38.2849 127.149C29.4136 127.354 19.9642 126.419 9.62462 123.93Z"
              fill="url(#paint1_linear_1966_10540)"
            ></path>
            <path
              d="M84.5874 119.602C84.5874 117.881 85.66 116.343 87.2708 115.747C88.0229 115.468 88.773 115.19 89.5216 114.912C103.652 109.666 117.265 104.613 133.654 102.903C144.336 101.788 156.338 102.092 170.424 104.912C176.899 106.208 179.941 113.485 176.779 119.294L87.6366 283.072C86.9796 284.279 85.7805 284.876 84.5874 284.863V119.602Z"
              fill="url(#paint2_linear_1966_10540)"
            ></path>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M361.952 71.8258C354.045 69.5663 346.703 68.4365 339.358 68.4365C325.803 68.4365 313.377 71.8258 302.08 77.4743C290.783 83.6876 282.311 92.1603 276.097 103.457C269.883 114.754 267.059 127.181 267.059 141.867C267.059 156.553 270.448 168.98 276.662 180.277C282.873 191.574 291.911 200.047 302.643 206.26C313.377 212.474 325.237 215.863 338.796 215.863C351.221 215.863 362.518 213.603 372.687 207.955C382.853 202.871 390.76 194.963 396.974 184.231C403.188 173.499 406.012 161.072 406.012 146.386V140.173C406.012 139.384 406.013 138.473 406.014 137.496L406.015 136.325C406.015 135.019 404.956 133.959 403.65 133.959H345.104C343.797 133.959 342.738 135.019 342.738 136.325V157.012C342.738 158.319 343.797 159.378 345.104 159.378H371.825C372.789 159.378 373.529 160.235 373.355 161.183C372.795 164.233 372.007 167.004 370.991 169.545C368.732 175.758 364.777 179.712 359.128 183.101C354.045 185.925 347.269 187.62 338.796 187.62C332.016 187.62 325.237 185.361 319.589 181.972C313.377 178.018 308.857 172.934 305.467 166.156C302.08 159.378 300.384 151.47 300.384 142.432C300.384 133.394 302.08 125.487 305.467 118.708C308.857 111.93 313.377 106.282 319.589 102.893C325.803 98.9386 332.582 97.2441 339.924 97.2441C346.703 97.2441 353.48 98.9386 359.128 101.763C364.149 104.273 368.725 108.568 372.455 113.855C373.226 114.947 374.729 115.261 375.833 114.508L396.847 100.18C397.873 99.4808 398.188 98.1034 397.512 97.0618C393.651 91.111 388.484 86.0881 382.853 81.9931C376.074 77.4743 369.863 74.085 361.952 71.8258ZM542.87 76.3988L568.076 69.7599C569.576 69.3648 571.044 70.4962 571.044 72.0474V211.238C571.044 212.544 569.985 213.603 568.679 213.603H543.473C542.166 213.603 541.107 212.544 541.107 211.238V78.6863C541.107 77.6119 541.831 76.6725 542.87 76.3988ZM840.218 135.089C844.172 132.829 848.126 131.699 852.645 131.699C857.728 131.699 861.682 133.394 865.071 135.089C868.46 136.783 871.285 140.172 873.544 144.691C875.803 149.21 876.933 154.293 876.933 160.507C876.933 166.72 875.803 171.804 873.544 176.323C871.849 180.841 869.025 184.231 865.071 186.49C861.682 188.749 857.163 189.879 852.645 189.879C848.126 189.879 843.607 188.749 840.218 186.49C836.829 184.231 834.005 180.841 831.745 176.323C829.486 171.804 828.356 166.72 828.356 160.507C828.356 154.293 829.486 149.21 831.745 144.691C833.44 140.737 836.264 137.348 840.218 135.089ZM880.887 111.93C872.979 107.411 863.377 105.151 852.645 105.151C842.477 105.151 832.875 107.411 824.402 111.93C815.929 116.448 809.716 123.227 804.632 131.699C799.549 140.172 797.289 149.775 797.289 160.507C797.289 171.239 800.113 180.842 804.632 189.314C809.151 197.787 815.929 204.565 824.402 209.084C832.875 213.603 842.477 215.862 852.645 215.862C862.812 215.862 872.414 213.603 880.887 209.084C889.36 204.565 895.573 197.787 900.657 189.314C905.74 180.842 908 171.239 908 160.507C908 149.775 905.176 140.172 900.657 131.699C896.138 123.227 889.36 116.448 880.887 111.93ZM667.091 202.836C667.314 202.478 667.963 202.642 667.963 203.065V211.238C667.963 212.545 669.022 213.604 670.329 213.604H695.534C696.84 213.604 697.899 212.545 697.899 211.238V110.907C697.899 109.601 696.84 108.542 695.534 108.542H670.329C669.022 108.542 667.963 109.601 667.963 110.907V119.999C667.963 120.775 666.935 121.101 666.461 120.485C664.876 118.423 663.112 116.507 661.184 114.755C654.971 108.542 646.499 105.717 636.331 105.717C627.294 105.717 619.385 107.977 612.042 113.061C605.264 117.58 599.616 124.358 595.662 132.831C591.708 141.303 590.013 150.906 590.013 161.073C590.013 171.24 591.708 180.843 595.662 189.316C599.616 197.788 604.7 204.002 612.042 209.085C618.821 214.169 627.294 216.428 636.331 216.428C647.064 216.428 654.971 213.039 661.749 208.52C664.336 206.796 666.119 204.393 667.091 202.836ZM656.666 185.926C652.712 188.186 648.757 189.316 644.238 189.316C639.721 189.316 635.767 188.186 631.812 185.926C628.424 183.667 625.599 180.278 623.339 175.759C621.646 171.24 620.515 166.157 620.515 160.508C620.515 154.86 621.08 150.341 623.339 145.822C625.599 141.868 628.424 138.479 631.812 136.22C635.767 133.96 639.721 132.831 644.238 132.831C648.757 132.831 653.276 133.96 656.666 136.22C660.054 138.479 662.879 141.303 665.139 145.822C666.834 149.776 667.963 154.86 667.963 160.508C667.963 166.157 667.398 171.24 665.139 175.759C662.879 180.278 660.054 183.667 656.666 185.926ZM763.632 131.7C763.197 131.7 762.844 132.053 762.844 132.488V172.934C762.844 182.536 766.797 187.62 774.706 187.62H783.637C784.944 187.62 786.003 188.679 786.003 189.985V211.238C786.003 212.544 784.944 213.603 783.637 213.603H770.752C758.89 213.603 749.288 210.214 743.074 203.436C736.296 196.658 732.906 187.055 732.906 174.628V132.488C732.906 132.053 732.553 131.7 732.118 131.7H714.641C713.02 131.7 711.879 130.106 712.401 128.572L718.675 110.144C719.002 109.185 719.902 108.541 720.915 108.541H732.118C732.553 108.541 732.906 108.188 732.906 107.752V79.4751C732.906 78.4007 733.63 77.4613 734.669 77.1876L760.865 70.2882C761.865 70.0248 762.844 70.779 762.844 71.8131V107.752C762.844 108.188 763.197 108.541 763.632 108.541H784.276C785.897 108.541 787.037 110.134 786.515 111.669L780.241 130.097C779.914 131.055 779.014 131.7 778.002 131.7H763.632ZM472.426 105.151C482.592 105.151 491.065 107.411 498.408 111.93C505.751 116.448 511.964 123.227 515.918 131.699C520.437 140.172 522.131 149.775 522.131 160.507V165.485C522.131 166.791 521.072 167.85 519.766 167.85H452.73C451.773 167.85 451.035 168.695 451.199 169.637C451.693 172.465 452.388 174.948 453.219 176.887C455.48 181.406 458.304 184.796 461.691 186.49C465.081 188.185 469.601 189.879 475.25 189.879C480.333 189.879 485.416 188.749 488.806 187.055C492.073 185.654 494.955 183.097 497.451 180.019C498.309 178.96 499.866 178.742 500.925 179.601L518.103 193.528C519.091 194.329 519.273 195.772 518.468 196.756C513.653 202.645 507.862 207.13 500.667 210.214C492.759 213.603 484.285 215.297 475.25 215.297C464.516 215.297 454.915 213.038 446.442 208.519C437.969 204 431.755 197.222 427.238 188.749C422.717 180.276 420.458 170.674 420.458 159.942C420.458 149.21 422.717 139.607 427.238 131.135C431.755 122.662 437.969 116.448 445.877 111.365C453.784 107.411 462.257 105.151 472.426 105.151ZM453.395 148.08C452.4 148.08 451.652 147.169 451.888 146.203C452.879 142.14 454.316 138.811 456.043 136.218C459.432 131.134 465.081 128.31 472.426 128.31C479.202 128.31 484.851 131.134 488.24 136.218C489.929 138.751 491.336 142.125 492.324 146.2C492.559 147.168 491.811 148.08 490.815 148.08H453.395Z"
              fill="#EFE0E0"
            ></path>
            <defs>
              <radialGradient
                id="paint0_radial_1966_10540"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(134.475 24.0499) rotate(149.79) scale(143.272 171.845)"
              >
                <stop offset="0.116813" stopColor="#FFF7F7"></stop>
                <stop offset="0.734375" stopColor="#8F7D7D"></stop>
                <stop offset="1" stopColor="#9D8E8E"></stop>
              </radialGradient>
              <linearGradient
                id="paint1_linear_1966_10540"
                x1="89.0177"
                y1="106.65"
                x2="89.0177"
                y2="284.863"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#917F7F"></stop>
                <stop offset="0.46875" stopColor="#907E7E"></stop>
                <stop offset="1" stopColor="#968484"></stop>
              </linearGradient>
              <linearGradient
                id="paint2_linear_1966_10540"
                x1="131.313"
                y1="102.301"
                x2="131.313"
                y2="296.732"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#F1ECEC"></stop>
                <stop offset="0.197917" stopColor="#EFE0E0"></stop>
                <stop offset="1" stopColor="#A99E9E"></stop>
              </linearGradient>
            </defs>
          </svg>
        </a>
      </div>
      <div className="flex-none">
        <ul className="menu menu-horizontal">
          <li className="z-10"  tabIndex={0}>
            <a
         
            >
              Docs
              <svg
                className="fill-current"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
              </svg>
            </a>
            <ul className="p-2 bg-base-100">
              <li>
                <a
                  href="https://docs.gelato.network/developer-services/automate"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                 Gelato Automate
                </a>
              </li>
              <li>
                <a
                  href="https://docs.gelato.network/developer-services/relay"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gelato Relay
                </a>
              </li>
              <li>
                <a
                  href="https://docs.gelato.network/developer-services/web3-functions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                 Web3 Functions
                </a>
              </li>
              <li>
                <a
                  href="https://docs.gelato.network/developer-services/gasless-wallet"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gelato Gasless Wallet
                </a>
              </li>
            </ul>
          </li>
          <li className="z-10 contact-us"  tabIndex={1}>
            <a >
              Contact Us
              <svg
                className="fill-current"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
              </svg>
            </a>
            <ul className="p-2 bg-base-100">
              <li>
                <a
                  href="https://discord.gg/ApbA39BKyJ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Discord
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/gelatonetwork"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Telegram
                </a>
              </li>
            </ul>
          </li>
          <li className="connect">
            {!props.connected ? (
              <button
        
                className="btn bg-connect-button"
                onClick={props.connectButton}
              >
                {" "}
                Connect Wallet{" "}
              </button>
            ) : (
              <button className="btn bg-connect-button">
                {" "}
                <img src={metamask} width={25} height={25} />{" "}
                {props.address.slice(0, 5) + "..." + props.address.slice(-3)}{" "}
              </button>
            )}
            {/* <ConnectWallet accentColor="#6519e6" colorMode="dark" /> */}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NavBar;
